import React from 'react';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import IconOrder from '../../../assets/icons/IconOrder.svg';
import { SUBCATEGORY_SORT_OPTIONS } from '../collectionProductSort';

const selectDisplayValue = (value) => {
    if (value === null || value === undefined || value === '') return '';
    return String(value);
};

const SubcategoryProductSortSelect = ({ value, onChange, disabled, fullWidth }) => (
    <div
        style={{
            display: 'flex',
            flexDirection: fullWidth ? 'column' : 'row',
            alignItems: fullWidth ? 'stretch' : 'center',
            marginBottom: 10,
            gap: fullWidth ? 8 : 6,
        }}
        onClick={(e) => e.stopPropagation()}
    >
        <FormLabel
            component="span"
            style={{
                margin: 0,
                display: 'flex',
                alignItems: 'center',
                fontSize: 13,
                whiteSpace: 'nowrap',
                color: 'rgba(0, 0, 0, 0.6)',
            }}
        >
            <img style={{ marginRight: 4, width: 14, height: 14 }} src={IconOrder} alt="" />
            Ordenar por
        </FormLabel>
        <FormControl
            variant="outlined"
            size="small"
            fullWidth={fullWidth}
            style={fullWidth ? { width: '100%' } : { flex: '0 1 auto', minWidth: 0 }}
        >
            <Select
                value={selectDisplayValue(value)}
                onChange={onChange}
                onClick={(e) => e.stopPropagation()}
                displayEmpty
                disabled={disabled}
                style={{ fontSize: 13, ...(fullWidth ? { width: '100%' } : { maxWidth: 280 }) }}
            >
                <MenuItem value="">
                    <em style={{ fontSize: 13 }}>Orden por defecto</em>
                </MenuItem>
                {SUBCATEGORY_SORT_OPTIONS.map((option) => (
                    <MenuItem key={option.id} value={String(option.id)}>
                        {option.name}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    </div>
);

export default SubcategoryProductSortSelect;
